import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { AccordionSummary, Accordion, AccordionDetails, Typography } from "@material-ui/core";
import QuestionsMap from "./questionsMap";
import { useStyles } from "examsbook-react-sdk/custom-hooks";

/**
 * QuizSectionMap
 * @param props
 * @returns {*}
 * @constructor
 */
const QuizSectionMap = props => {
    const { index, counter, item, selectPaletteQuestion, viewMode, handleSectionChange, quiz } = props;
    const classes = useStyles(styles)({ item });
    const [ expanded, setExpanded ] = React.useState(true);

    return (
        <Accordion expanded={expanded} onChange={() => setExpanded(!expanded)}>
            <AccordionSummary
                className={classNames(classes.expansionSummaryPanel)}
                aria-controls="panel1a-content"
                id="panel1a-header"
                expanded={"true"}
                onClick={() => handleSectionChange(index)}>
                <Typography
                    className={classes.heading}>{item?.section?.en}</Typography>
                    {item?.sectionPassingPercent > 0 && <Typography className={classes.headingPercent}>Min. Passing marks: {item?.sectionPassingPercent}%</Typography>}
            </AccordionSummary>
            <AccordionDetails
                className={classNames(classes.expansionDetailsPanel)}>
                <QuestionsMap questions={item.questions} viewMode={viewMode}
                              selectPaletteQuestion={selectPaletteQuestion}
                              counter={counter} quiz={quiz}
                              index={index}/>

            </AccordionDetails>
        </Accordion>
    );
};

const styles = theme => ({
    expansionSummaryPanel: {
        minHeight: 'inherit !important',
        padding: '0px 17px',
        pointerEvents: 'none',
        background: '#f3f3f3',
        height: props => (props.item?.sectionPassingPercent > 0 ? "60px" : "30px"),
        justifyContent: 'left',
        "& div": {
            flexDirection: 'column',
            alignItems: 'flex-start'
        }
    },
    expansionDetailsPanel: {
        padding: '10px 17px',
        paddingBottom: 10,
    },
    heading: {
        fontSize: 15,
        color: '#000',
        textTransform: 'capitalize',
    },
    headingPercent: {
        fontSize: 12,
        color: '#202020',
        textTransform: 'capitalize',
    }
});

QuizSectionMap.propTypes = {
    index: PropTypes.number,
    counter: PropTypes.number,
    item: PropTypes.shape({
        section: PropTypes.shape({
            en: PropTypes.string,
        }),
        sectionPassingPercent: PropTypes.number,
        questions: PropTypes.array,
    }),
    selectPaletteQuestion: PropTypes.func,
    viewMode: PropTypes.bool,
    handleSectionChange: PropTypes.func,
    quiz: PropTypes.object,
};

export default QuizSectionMap;
